import React from 'react'
import { Trophy } from 'lucide-react'

import { Badge } from '@rewardops/replit/src/components/ui/badge'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@rewardops/replit/src/components/ui/card'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const TierDistribution: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()

  const { data: tierDistribution, isLoading } =
    api.pawDashboards.getByRole.useQuery({
      role: data?.role,
      sectionId: 'tier-distribution',
    })

  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Partner Tier Distribution'}
      </h2>
      <Card className="overflow-visible">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-primary" />
            Tier Breakdown
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {['Platinum', 'Gold', 'Silver', 'Bronze'].map((tier) => {
              const count = Math.floor(Math.random() * 9) + 1
              const percent = Math.round((count / 10) * 100)
              return (
                <div key={tier} className="flex items-center gap-3">
                  <Badge variant="outline" className="w-20 justify-center">
                    {tier}
                  </Badge>
                  <div className="h-2 flex-1 rounded-full bg-muted">
                    <div
                      className="h-2 rounded-full bg-tenant-primary-color"
                      style={{ width: `${percent}%` }}
                    />
                  </div>
                  <span className="w-16 text-right text-sm font-semibold tabular-nums">
                    {count} ({percent}%)
                  </span>
                </div>
              )
            })}
          </div>
        </CardContent>
      </Card>
    </section>
  )
}
